// Catalog product-category URNs the app keys behavior on.
// "Systems and solutions" (catalog id 188): assets in this category are serviced
// on site instead of being removed, so the column nameplate swaps its remove
// action for an on-site-intervention event.
export const SYSTEMS_AND_SOLUTIONS_CATEGORY_URN = "urn:product-category:systemsandsolutions";
